export interface IUploadState {
    dokumentTypes: Array<object>,
    schlagwortVorschlaege: Array<string>
}

export const state: IUploadState = {
    dokumentTypes: [],
    schlagwortVorschlaege:[]
};
